import { Button, ButtonProps, Typography, TypographyProps, Tooltip } from '@mui/material';
import { ReactElement, useEffect, useRef, useState } from 'react';

const isEllipsisActive = (elem: HTMLSpanElement): boolean => {
    return elem.offsetWidth < elem.scrollWidth;
};
type ButtonTruncatedProps = ButtonProps & {
    typography?: TypographyProps;
};
export const ButtonTruncated: (props: ButtonTruncatedProps) => ReactElement = ({ children, typography, ...props }) => {
    // eslint-disable-next-line no-null/no-null, @typescript-eslint/no-non-null-assertion
    const textRef = useRef<HTMLSpanElement>(null!);
    const [tooltipEnabled, setTooltipEnabled] = useState(false);
    useEffect(() => {
        setTooltipEnabled(isEllipsisActive(textRef.current));
    }, [children]);

    return (
        <Tooltip title={children} disableHoverListener={!tooltipEnabled} disableTouchListener={!tooltipEnabled}>
            <Button {...props}>
                <Typography ref={textRef} variant='button' {...typography} noWrap>
                    {children}
                </Typography>
            </Button>
        </Tooltip>
    );
};
